import { render, staticRenderFns } from "./RxBySimpleViewSelector.vue?vue&type=template&id=584d554b"
import script from "./RxBySimpleViewSelector.vue?vue&type=script&lang=js"
export * from "./RxBySimpleViewSelector.vue?vue&type=script&lang=js"
import style0 from "./RxBySimpleViewSelector.vue?vue&type=style&index=0&id=584d554b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports